import { makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddOutlined';
import RemoveIcon from '@material-ui/icons/Clear';
import React, { memo, useEffect, useState } from 'react';

import useFileReader from '../../../custom-hooks/useFileReader';
import CustomFileInput, { ControlProps } from '../../../ui/CustomFileInput';

const useStyles = makeStyles({
  imageWrapper: {
    width: '100%',
    border: '1px solid #c4c4c4',
  },
  image: {
    paddingTop: 114,
    position: 'relative',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
  },
  remove: {
    display: 'flex',
    position: 'absolute',
    top: 6,
    right: 6,
    cursor: 'pointer',
    background: '#fff',
    borderRadius: '50%',
    padding: 0,
    zIndex: 100,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    '&:hover': {
      background: '#fff',
    },
  },
});

type Props = {
  fdKey: string;
  image?: string;
  onLoad?: (data: string) => void;
  onChange: (data: FileList | null) => void;
};

export default memo(function EditWebsiteSettingsUploadImage(props: Props) {
  const classes = useStyles();
  const { fdKey, onChange, image = '', onLoad } = props;
  const [imageSrc, setImageSrc] = useState(image);

  const loadFile = useFileReader((data: string) => {
    setImageSrc(data);
    if (onLoad) {
      onLoad(data);
    }
  });

  useEffect(
    () => {
      setImageSrc(image);
    },
    [image]
  );

  return (
    <div className={classes.imageWrapper}>
      <div className={classes.image} style={{ backgroundImage: `url(${imageSrc})` }}>
        <CustomFileInput
          fdKey={fdKey}
          onChange={(files: FileList | null) => {
            onChange(files);
            if (files && files[0]) {
              loadFile(files[0]);
            }
          }}
        >
          {(controls: ControlProps) => {
            return imageSrc ? (
              <div
                data-fd={`${fdKey}_image_remove`}
                className={classes.remove}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onChange(null);
                  setImageSrc('');
                  controls.reset();
                }}
              >
                <RemoveIcon htmlColor="#ff395f" />
              </div>
            ) : (
              <AddIcon htmlColor="#05149e" />
            );
          }}
        </CustomFileInput>
      </div>
    </div>
  );
});
